export default __webpack_public_path__ + "static/media/complementary--roundabout-go-left--g1.4b39fec6.png";